import React from 'react';
import { Button, Col, Row, Select, Space, Table } from 'antd';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
    SortableContext,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import type { ColumnsType } from 'antd/es/table';
import EditorCard from '../content/editorCard'; // Adjust path as needed
import { Flex } from 'antd';
import type { SensorDescriptor } from '@dnd-kit/core';
import { MenuOption, DragRowProps } from '../../types/types';
import { StoresListToPublish } from '../../types/storetypes';


interface MenuOptionGroupOptionsProps {
    selectedMogOptions: MenuOption[];
    columnsSort: ColumnsType<MenuOption>;
    sensors: SensorDescriptor<any>[];
    handleDragEnd: (event: any) => void;
    isAddOptionButtonDisabled: boolean;
    handleNewMenuOption: () => void;
    DragRow: React.FC<DragRowProps>;
    stores: StoresListToPublish[];
    selectedStoreGuid: string | null;
    onStoreChange: (storeGuid: string) => void;
}


const MenuOptionGroupOptions: React.FC<MenuOptionGroupOptionsProps> = ({
    selectedMogOptions,
    columnsSort,
    sensors,
    handleDragEnd,
    isAddOptionButtonDisabled,
    handleNewMenuOption,
    DragRow,
    stores,
    selectedStoreGuid,
    onStoreChange
}) => {
    return (
        <EditorCard
            title={
                <Row>
                    <Col span={4} style={{ textAlign: 'left' }}>
                        Group Options
                    </Col>
                    <Col span={20} style={{ textAlign: 'right' }}>
                        <Button
                            color="green"
                            variant="solid"
                            size="small"
                            disabled={isAddOptionButtonDisabled}
                            onClick={handleNewMenuOption}
                        >
                            Add Option
                        </Button>
                    </Col>
                </Row>
            }
        >
            <Space direction="vertical" size="middle">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ maxWidth: "80%" }}>
                        <p style={{ marginBottom: 0 }}>
                            Select a store to view prices for the menu options below.
                            The prices shown are specific to the store you choose.
                        </p>
                    </div>
                    <Select
                        showSearch
                        placeholder="Select Store"
                        value={selectedStoreGuid}
                        onChange={onStoreChange}
                        style={{ width: 250 }}
                        options={stores.map(store => ({
                            label: store.storeNumber, // shown text
                            value: store.guid,        // underlying value
                        }))}
                        filterOption={(input, option) =>
                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </div>
                <Flex>
                    <DndContext
                        sensors={sensors}
                        modifiers={[restrictToVerticalAxis]}
                        collisionDetection={closestCenter}
                        onDragEnd={handleDragEnd}
                    >
                        <SortableContext
                            items={selectedMogOptions?.map((i) => i.key) || []}
                            strategy={verticalListSortingStrategy}
                        >
                            <Table
                                pagination={false}
                                columns={columnsSort}
                                rowKey="key"
                                dataSource={selectedMogOptions}
                                components={{
                                    body: {
                                        row: (props) => DragRow(props),
                                    },
                                }}
                            />
                        </SortableContext>
                    </DndContext>
                </Flex>
            </Space>
        </EditorCard >
    );
};

export default MenuOptionGroupOptions;